import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Form, Field, FormRenderProps } from 'react-final-form';
import FontAwesomeIcon from 'react-fontawesome';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { initialRequest } from './actions/Actions';
import { CLOUDINARY_BASE_URL, PRODUCT_CATEGORIES, required } from './Constants';
import { Store } from './types';

interface FormValues {
    username: string;
    password: string;
    storeId: string;
}

const Login: React.FC<RouteComponentProps> = ({ history }) => {
    const [loading, setLoading] = React.useState(false);
    const dispatch: ThunkDispatch<Store, unknown, AnyAction> = useDispatch();

    const renderForm = React.useCallback(
        ({ handleSubmit, submitting, validating }: FormRenderProps) => (
            <form className='login-form' onSubmit={handleSubmit}>
                <div className='title'>SCAN + ORDER ADMINISTRATION</div>
                <Field name='storeId' validate={required()}>
                    {({ input, meta }) => (
                        <div className='field-input'>
                            <FontAwesomeIcon name='id-badge' className='input-icon' />
                            <input
                                {...input}
                                type='number'
                                placeholder='Store ID'
                                min={0}
                            />
                            {meta.error && meta.touched && (
                                <FontAwesomeIcon
                                    className='error-icon'
                                    name='exclamation-circle'
                                    title={meta.error}
                                />
                            )}
                        </div>
                    )}
                </Field>
                <Field name='username' validate={required()}>
                    {({ input, meta }) => (
                        <div className='field-input'>
                            <FontAwesomeIcon name='user' className='input-icon' />
                            <input {...input} type='text' placeholder='Username' />
                            {meta.error && meta.touched && (
                                <FontAwesomeIcon
                                    className='error-icon'
                                    name='exclamation-circle'
                                    title={meta.error}
                                />
                            )}
                        </div>
                    )}
                </Field>
                <Field name='password' validate={required()}>
                    {({ input, meta }) => (
                        <div className='field-input'>
                            <FontAwesomeIcon name='lock' className='input-icon' />
                            <input {...input} type='password' placeholder='Password' />
                            {meta.error && meta.touched && (
                                <FontAwesomeIcon
                                    className='error-icon'
                                    name='exclamation-circle'
                                    title={meta.error}
                                />
                            )}
                        </div>
                    )}
                </Field>
                <div className='submit-wrapper'>
                    {loading && <FontAwesomeIcon name='spinner' className='fa-spin' />}
                    <button
                        className='submit-button'
                        type='submit'
                        disabled={submitting || validating}>
                        Login
                    </button>
                </div>
                <img
                    src={`${CLOUDINARY_BASE_URL}/backoffice/powered_by_personalized.png`}
                />
            </form>
        ),
        [loading]
    );

    const handleLogin = React.useCallback(
        ({ username, password, storeId }: FormValues) => {
            setLoading(true);

            dispatch(initialRequest(username, password, Number(storeId)))
                .then(() => {
                    history.push(PRODUCT_CATEGORIES);
                })
                .catch(() => {
                    setLoading(false);
                });
        },
        [dispatch, history]
    );

    return (
        <div className='login'>
            <Form onSubmit={handleLogin} render={renderForm} />
        </div>
    );
};

export default withRouter(Login);
